module.exports = __webpack_public_path__ + "img/certif_05.2e47a6bf.jpg";